"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var b=require("../utils/resizeObservers.js"),a=function(){return b.resizeObservers.some(function(a){return a.activeTargets.length>0})};exports.hasActiveObservations=a
//# sourceMappingURL=hasActiveObservations.js.map
